import React from 'react'

const Social = () => {
  return (
    <div className="home_social">
        <a href="https://www.linkedin.com/in/dcggutierrez/" className="home_social-icon" target={"_blank"} rel="noreferrer">
            <i className="uil uil-linkedin"></i>
        </a>
        <a href="https://github.com/dcggutierrez" className="home_social-icon" target={"_blank"} rel="noreferrer">
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social